import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Report from "../../../models/Report";
import DataTable from "../dataTable";

const initialTable = {
    page: 1,
    term: "",
    sort: "percentage",
    order: "desc",
    limit: 25,
};

export default function GolfClubTeeTimeCompletionRate() {
    const [loading, setLoading] = useState(true);
    const [table, setTable] = useState(initialTable);
    const [totalRecords, setTotalRecords] = useState(0);
    const [data, setData] = useState([]);

    const getData = useCallback(async (params) => {
        setLoading(true);
        const response = await Report.golfClubTeeTimeCompletionRate(params);
        setData(response.items);
        setTotalRecords(response.total);
        setTable(params);
        setLoading(false);
    }, []);

    useEffect(() => {
        getData(initialTable);
    }, [getData]);

    const headers = [
        { key: "golfClub", text: "Golf club" },
        { key: "totalRequests", text: "Total tee-time requests" },
        { key: "completedBookings", text: "Completed tee-time bookings" },
        { key: "percentage", text: "% completed" },
    ];
    const tableData = data.map((item) => {
        const percentage = Number(item.percentage || 0);
        return {
            golfClub: {
                value: (
                    <Link to={`/golf-clubs/${item._id}`}>{item.name}</Link>
                ),
                search: item.name,
            },
            totalRequests: {
                value: item.totalRequests,
                search: item.totalRequests,
            },
            completedBookings: {
                value: item.completedBookings,
                search: item.completedBookings,
            },
            percentage: {
                value: `${percentage.toFixed(2)}%`,
                search: percentage,
            },
        };
    });

    return (
        <>
            <h4>Golf club tee-time completion rate</h4>
            <p>
                The all-time completion rate for tee-time requests attributed to
                each golf club.
            </p>
            <DataTable
                loading={loading}
                headers={headers}
                data={tableData}
                totalRecords={totalRecords}
                page={table.page}
                onChange={getData}
                searchTerm={table.term}
                sort={table.sort}
                order={table.order}
                limit={table.limit}
                sortOptions={[
                    { text: "% completed", key: "percentage" },
                    { text: "Golf club", key: "name" },
                    { text: "Total tee-time requests", key: "totalRequests" },
                    {
                        text: "Completed tee-time bookings",
                        key: "completedBookings",
                    },
                ]}
                pagination
            />
        </>
    );
}
